import React from "react";
import { cn } from "../../lib/cn";

/** Simple checkbox + Checkbox.Group */
export function Checkbox({ checked, indeterminate, onChange, disabled, children, className }) {
  return (
    <label className={cn("inline-flex items-center gap-2 cursor-pointer select-none text-sm text-slate-800", disabled && "opacity-50 cursor-not-allowed", className)}>
      <input
        type="checkbox"
        className={cn(
          "h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand"
        )}
        checked={!!checked}
        ref={(el) => {
          if (el) el.indeterminate = !!indeterminate;
        }}
        disabled={disabled}
        onChange={(e) => onChange?.({ target: { checked: e.target.checked } })}
      />
      {children}
    </label>
  );
}

export function CheckboxGroup({ value = [], onChange, options, children }) {
  if (options) {
    return (
      <div className="flex flex-col gap-2">
        {options.map((opt) => {
          const v = typeof opt === "object" ? opt.value : opt;
          const label = typeof opt === "object" ? opt.label : opt;
          return (
            <Checkbox
              key={v}
              checked={value?.includes?.(v)}
              onChange={({ target }) => {
                const next = new Set(value || []);
                if (target.checked) next.add(v);
                else next.delete(v);
                onChange?.([...next]);
              }}
            >
              {label}
            </Checkbox>
          );
        })}
      </div>
    );
  }
  return <div className="flex flex-col gap-2">{children}</div>;
}
